import React from 'react';
import { motion } from 'framer-motion';
export function AuthorSection() {
  return <section className="bg-[#1A2744] text-white py-20 px-5" data-id="element-12">
      <div className="max-w-5xl mx-auto" data-id="element-13">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center md:text-left" data-id="element-15">
            <h2 className="text-3xl md:text-4xl lg:text-5xl mb-6 leading-tight" data-id="element-16">
              Una voz que entiende a las familias
            </h2>
            <p className="text-base md:text-lg text-[#B8C8E8] leading-relaxed mb-5" data-id="element-17">
              Esta guía nació de años de acompañar a familias en los momentos
              más desafiantes de la crianza. Basada en investigaciones de
              neurociencia del desarrollo, psicología familiar y comunicación
              efectiva.
            </p>
            <p className="text-base md:text-lg text-[#B8C8E8] leading-relaxed" data-id="element-18">
              No es un libro académico. No es de 200 páginas. Es una solución
              rápida a un problema urgente. Es la guía que deseamos que alguien
              nos hubiera dado cuando llegó la adolescencia a casa práctica,
              honesta, sin juicios y llena de esperanza.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-shrink-0 text-center" data-id="element-19">
            <img src="https://cdn.magicpatterns.com/uploads/6q3p4dro9egKnUtMXfvwo4/bajaresolu.png" alt="Delfia Cortes" className="w-56 h-56 md:w-64 md:h-64 rounded-2xl object-cover shadow-lg" data-id="element-20" />
            <p className="mt-4 text-lg font-semibold text-white" data-id="element-21">
              Delfia Cortes
            </p>
            <p className="text-sm text-[#B8C8E8]" data-id="element-22">Autora</p>
          </motion.div>
        </div>
      </div>
    </section>;
}